import { absolutePath } from "../../absolutePath";

export const attributions = {
  create: () => absolutePath("paywalls/affiliates/attributions"),
  destroy: () => absolutePath("paywalls/affiliates/attributions"),
};
